import '../index.css';
import './SearchBarHome.css';
import { useState } from 'react';
import { useHistory } from 'react-router';

const SearchBarHome = (props) => {

    const [isDisplay, setisDisplay] = useState(true);
    const [keyword, setKeyword] = useState('')
    const history = useHistory();

    const handleClick = () => {
        setisDisplay(false);
        console.log(isDisplay);
    }

    const onSearch = () => {
        history.push('/info?keyword=' + keyword);
    }
    return ( 
        <div className="search-bar-home mt-4">
            <div className="search-box search-form">
                <a href="/" className="maps">
                    <div className="loc-logo">
                        <svg width="48%" height="50%" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M13.0432 7.49393e-05C6.12965 -0.0234123 0.482644 5.47703 0.256942 12.362L0.25 12.7894C0.364913 16.1641 1.51311 19.381 3.53542 22.0314L4.01038 22.6512C5.9407 25.1057 8.23467 27.26 10.8104 29.0357L11.4306 29.4531L11.5211 29.5242C12.4039 30.1585 13.5959 30.1585 14.4787 29.5242L14.554 29.4623C16.5978 28.1368 18.4825 26.5794 20.1707 24.8209C23.6029 21.1878 25.6716 17.1169 25.7496 12.9825L25.7499 12.829C25.7733 5.89788 20.2898 0.233505 13.4259 0.00703563L13.0432 7.49393e-05ZM13.0355 2.27622C18.7033 2.2956 23.305 6.82415 23.4759 12.4637L23.4807 12.9609C23.4151 16.4272 21.6002 19.9987 18.5299 23.2487C16.9644 24.8794 15.2091 26.3289 13.3053 27.5617L13.1785 27.6571C13.0759 27.7461 12.9239 27.7461 12.8213 27.6571L12.698 27.564C9.86196 25.7124 7.37285 23.3746 5.34455 20.6576C3.71077 18.5163 2.74263 15.9561 2.54776 13.2854L2.51913 12.7498C2.53838 7.06835 7.05298 2.4525 12.6752 2.2811L13.0355 2.27622ZM12.9999 8.10194C10.3173 8.10194 8.14263 10.2833 8.14263 12.9742C8.14263 15.6651 10.3173 17.8464 12.9999 17.8464C15.6825 17.8464 17.8572 15.6651 17.8572 12.9742C17.8572 10.2833 15.6825 8.10194 12.9999 8.10194ZM12.9999 10.3781C14.4293 10.3781 15.588 11.5404 15.588 12.9742C15.588 14.408 14.4293 15.5703 12.9999 15.5703C11.5705 15.5703 10.4118 14.408 10.4118 12.9742C10.4118 11.5404 11.5705 10.3781 12.9999 10.3781Z" fill="#FFB301"/>
                        </svg>
                    </div>
                </a>
                <input 
                    type="text" 
                    className="input" 
                    name="search-poi" 
                    data-testid="searchbar-home"
                    id="search" 
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && onSearch()}
                    placeholder="Cari destinasimu di sini ..."/>
                <button data-testid="search-button" id="search-button" onClick={onSearch}>Cari</button>
            </div>
            
            <div style={{ "display" : isDisplay ? "flex":"none" }} className="info-box">
                <p className="footnote text-info-maps">
                    Kamu bisa memilih destinasi via maps 
                </p>
                <div className="exit" >
                    <svg onClick={handleClick} className="exit" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.2501 4.75831C14.9251 4.43331 14.4001 4.43331 14.0751 4.75831L10.0001 8.82498L5.9251 4.74998C5.6001 4.42498 5.0751 4.42498 4.7501 4.74998C4.4251 5.07498 4.4251 5.59998 4.7501 5.92498L8.8251 9.99998L4.7501 14.075C4.4251 14.4 4.4251 14.925 4.7501 15.25C5.0751 15.575 5.6001 15.575 5.9251 15.25L10.0001 11.175L14.0751 15.25C14.4001 15.575 14.9251 15.575 15.2501 15.25C15.5751 14.925 15.5751 14.4 15.2501 14.075L11.1751 9.99998L15.2501 5.92498C15.5668 5.60831 15.5668 5.07498 15.2501 4.75831Z" fill="white"/>
                    </svg>
                </div>
            </div>
        </div>
     );
}
 
export default SearchBarHome;